/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PracticeCertificateSigningEnum {
	None = "None",
	Tutor = "Tutor",
	PracticeRepresentative = "PracticeRepresentative",
	Student = "Student",
}

export function PracticeCertificateSigningEnumFromJSON(
	json: any
): PracticeCertificateSigningEnum {
	return PracticeCertificateSigningEnumFromJSONTyped(json, false);
}

export function PracticeCertificateSigningEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeCertificateSigningEnum {
	return json as PracticeCertificateSigningEnum;
}

export function PracticeCertificateSigningEnumToJSON(
	value?: PracticeCertificateSigningEnum | null
): any {
	return value as any;
}
